<template>
  <router-view></router-view>
</template>
<script>
import RegisterStoreModule from '@/mixins/RegisterStoreModule'
import profileStore from './store.js'

export default {
  name: 'profile',
  mixins: [RegisterStoreModule],
  created() {
    this.registerStoreModule('profile', profileStore)
  },
}
</script>
